import { useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  OutlinedInput,
  Typography,
  Avatar,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostAPI } from "../../Components/Backend/PostAPI";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import PageTitle from "../../components/Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import InputAdornment from "@mui/material/InputAdornment";
import ListIcon from "@mui/icons-material/List";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const ColaboradorIncluir = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(4); //Colaboradores
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  //***************************************   SALVAR e SALVAR + NOVO ********************************* */
  const [modoIncluirMais, setModoIncluirMais] = useState(false);
  //************************************************************************************************** */

  const navigate = useNavigate();
  const apiAxios = APIAxios();

  const [grupos, setGrupos] = useState([]);
  const [gruposSelecionados, setGruposSelecionados] = useState([]);
  const [jornadasSelecionadas, setJornadasSelecionadas] = useState([]);
  const [jornadas, setJornadas] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    nome: "",
    cargo: "",
    idEmpresa: 0,
    idGrupo: 0,
    idCalendario: 0,
  });

  // Este estado guarda o arquivo real (file) para o envio ao servidor
  const [avatarFile, setAvatarFile] = useState(null);

  // Este estado guarda a URL temporária para exibir a imagem na tela
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      // 1. Salva o arquivo no estado para enviar depois no formulário
      setAvatarFile(file);

      // 2. Gera uma URL temporária para visualização imediata
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    }
  };

  const carregarAvatar = async (id) => {
    //Carrega identificação das imagens
    const response = await GetAPI(apiAxios, "/colab/avatar/" + id, {
      responseType: "blob",
    });

    // Cria uma URL temporária para o blob recebido
    const blobUrl = URL.createObjectURL(response.data);

    setFormData((prev) => ({
      ...prev,
      avatarUrl: blobUrl,
    }));
  };

  const uploadAvatar = async (file, id) => {
    const fd = new FormData();
    fd.append("file", file);

    const resp = await apiAxios.post(`/colab/avatar/${id}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return resp.data;
  };

  //Busca Grupos no backend
  const buscaGrupos = async () => {
    setLoading(true);

    const response = await GetAPI(apiAxios, "/grupos");
    setLoading(false);

    if (response.success) {
      setGrupos(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  //Busca Jornadas no backend
  const buscaJornadas = async () => {
    setLoading(true);

    const response = await GetAPI(apiAxios, "/calendarios");
    setLoading(false);

    if (response.success) {
      setJornadas(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  useEffect(() => {
    buscaGrupos();
    buscaJornadas();
  }, []);

  const handleVoltar = () => {
    navigate("/colaboradores");
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;

    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: typeof valor === "string" ? valor.toUpperCase() : valor,
    }));
  };

  // Limpa os campos do formulário após a inclusão, se for incluir mais um registro
  const limparCampos = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    setPreviewUrl(null);
    setAvatarFile(null);

    setFormData({
      id: 0,
      nome: "",
      cargo: "",
      idEmpresa: 0,
      idGrupo: 0,
      idCalendario: 0,
    });
    setGruposSelecionados([]);
    setJornadasSelecionadas([]);
  };

  // Recebe o clique no botao SALVAR ou no SALVAR + INCLUIR
  // Se for SALVAR + INCLUIR, chama a função limparCampos para limpar os campos do formulário
  const handleSubmit = async (event) => {
    event.preventDefault();

    const registro = {
      nome: formData.nome.trim(),
      cargo: formData.cargo.trim(),
      idEmpresa: formData.idEmpresa,
      idCalendario: jornadasSelecionadas,
      idGrupo: gruposSelecionados,
    };
    setLoading(true);
    const response = await PostAPI(apiAxios, "/colab", registro);
    setLoading(false);

    if (response.success) {
      setFormData(response.data);

      if (avatarFile) {
        try {
          await uploadAvatar(avatarFile, response.data.id);
          carregarAvatar(response.data.id);
        } catch (err) {
          setAvisoErro("Falha ao enviar imagem.");
        }
      }

      //Exibe mensagem de sucesso por 5 segundos e limpa a tela
      setAvisoSucesso("Perfil de colaborador incluído com sucesso!");
      if (modoIncluirMais) {
        limparCampos();
      } else {
        await new Promise((resolve) => setTimeout(resolve, 3000)); // aguarda 3 segundos
        navigate("/colaboradores");
      }
    } else {
      setAvisoErro(response.errorMessage || "Erro ao atualizar colaborador.");
    }
  };

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Cadastro de Colaboradores"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <form onSubmit={handleSubmit}>
          {/* Grid Container Principal que divide a tela em duas colunas */}
          <Grid container spacing={4}>
            {/*AVATAR */}
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderRight: { md: "1px solid #e0e0e0" }, // Linha divisória lateral
                pr: { md: 4 },
              }}
            >
              <Avatar
                src={previewUrl}
                sx={{ width: 160, height: 160, mb: 2 }}
              />
              <Button
                variant="outlined"
                component="label"
                startIcon={<AttachFileIcon />}
                sx={{
                  mb: 1,
                  textTransform: "none",
                  width: "100%",
                  borderColor: "#1a3865",
                  color: "#1a3865",
                }}
              >
                Atualizar imagem
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </Button>

              <Typography variant="caption" color="textSecondary">
                PNG/JPG - até 2MB
              </Typography>
            </Grid>

            {/* --- COLUNA DA DIREITA --- */}
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>
                {/*Nome*/}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome:"
                    variant="outlined"
                    value={formData.nome}
                    onChange={(e) => handleChange(e, 50)}
                    required
                    name="nome"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/*Cargo*/}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Cargo:"
                    variant="outlined"
                    value={formData.cargo}
                    onChange={(e) => handleChange(e, 100)}
                    required
                    name="cargo"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/*Grupos*/}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="label-grupos">Grupo</InputLabel>
                    <Select
                      labelId="label-grupos"
                      value={gruposSelecionados}
                      onChange={(e) =>
                        setGruposSelecionados(Number(e.target.value))
                      }
                      input={<OutlinedInput label="Grupos" />}
                    >
                      {(grupos ?? []).map((group) => (
                        <MenuItem key={group.id} value={String(group.id)}>
                          {group.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/*Jornadas*/}
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label-jornadas">Jornada</InputLabel>
                    <Select
                      labelId="label-jornadas"
                      value={jornadasSelecionadas}
                      onChange={(e) =>
                        setJornadasSelecionadas(Number(e.target.value))
                      }
                      input={<OutlinedInput label="Jornadas" />}
                    >
                      {(jornadas ?? []).map((journey) => (
                        <MenuItem key={journey.id} value={String(journey.id)}>
                          {journey.descricao}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            {/* --- RODAPÉ (BOTÕES) --- */}
            <Grid
              item
              xs={12}
              sx={{ mt: 4, pt: 2, borderTop: "1px solid #eee" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" }, // Coluna no mobile, linha no desktop
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                {/* 1. BOTÃO VOLTAR */}
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1a3865",
                    px: 4,
                    width: { xs: "100%", md: "auto" },
                  }}
                  onClick={handleVoltar}
                >
                  VOLTAR
                </Button>

                {/* Container para os botões da direita */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 2,
                    width: { xs: "100%", md: "auto" },
                  }}
                >
                  {/* 2. SALVAR + INCLUIR */}
                  <Button
                    variant="outlined"
                    onClick={() => setModoIncluirMais(true)}
                    type="submit"
                    sx={{
                      borderColor: "#1a3865",
                      color: "#1a3865",
                      fontWeight: "bold",
                      width: { xs: "100%", md: "auto" },
                    }}
                  >
                    SALVAR + INCLUIR
                  </Button>

                  {/* 3. SALVAR */}
                  <Button
                    variant="contained"
                    type="submit"
                    onClick={() => setModoIncluirMais(false)}
                    sx={{
                      backgroundColor: "#1a3865",
                      fontWeight: "bold",
                      width: { xs: "100%", md: "auto" },
                    }}
                  >
                    SALVAR
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default ColaboradorIncluir;
